import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
// views
import { AddButton, ButtonsWrapper } from 'components/Modals/PropertyDetailsModal/components/Form/view'
// types
import { IOption } from 'components/FormElements/Select'
import { FieldArrayFieldsProps } from 'redux-form'
// themes
import colors from 'themes/colors'
// utils
import { required } from 'utils/validators'

const FieldsWrapper = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  background: ${colors.gray190};
  border-radius: 4px;
  padding: 8px 12px;
`

interface Props {
  fields: FieldArrayFieldsProps<IOption>
  removeField: (idx: number) => void
  createOption: (field: string, data: any, idx: number) => () => void
}

const OptionForm: React.FC<Props> = ({ fields, removeField, createOption }) => {
  const handleRemove = (idx: number) => () => {
    removeField(idx)
  }

  return (
    <>
      {fields.map((field, idx) => (
        <FieldsWrapper key={idx}>
          <ReduxInput name={`${field}.label`} label={'Label'} validate={required} />
          <ReduxInput name={`${field}.value`} label={'Value'} validate={required} />
          <ButtonsWrapper>
            <AddButton data-testid='picklist-option-save' onClick={createOption(field, fields.get(idx), idx)}>
              save
            </AddButton>
            <AddButton data-testid='picklist-option-cancel' onClick={handleRemove(idx)}>
              cancel
            </AddButton>
          </ButtonsWrapper>
        </FieldsWrapper>
      ))}
    </>
  )
}

export default OptionForm
